// extracted by css-extract-rspack-plugin
export default {"scrollableShortcuts":"scrollableShortcuts-UUEK1H","searchInput":"searchInput-hqodJU","shortcutRow":"shortcutRow-TMIP6G"};